import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Alert, Box } from '@mui/material';
import { UserContext } from '../../provider/user';
import { formatDateFromTimestamp } from '../../helpers/data';

export default function PricingPlanWarning() {
	const { user, pricingPlan, freeTrial } = React.useContext(UserContext);

	if (user?.role !== 'vendor' || false !== pricingPlan) {
		return null;
	}

	return (
		<Box mb={3} id="pricing-plan-warning">
			<Alert severity="info">
				{freeTrial ? (
					<Typography variant="body2" align="center">
						{`Your trial period will end at ${formatDateFromTimestamp(
							freeTrial,
						)}. Once it's over, your videos and content will be deactivated unless you subscribe. `}
						<Link
							component={RouterLink}
							to="/pricing"
							color="inherit"
							style={{ textDecoration: 'underline' }}
						>
							Subscribe
						</Link>{' '}
						to a package now to maintain your content searches.
					</Typography>
				) : (
					<Typography variant="body2" align="center">
						You're using a free plan. Please consider switching to one of our{' '}
						<Link
							component={RouterLink}
							to="/pricing"
							color="inherit"
							style={{ textDecoration: 'underline' }}
						>
							paid plans
						</Link>{' '}
						to start using all features.
					</Typography>
				)}
			</Alert>
		</Box>
	);
}
